<script>
  import { onMount } from 'svelte';
  import { createScene } from "./perlinx7";
  
  let el;
  
  onMount(() => {
    createScene(el)
  });
  

</script>

<canvas bind:this={el}></canvas>
